<template>
  <div :class="$style.filter">
    <el-skeleton animated :loading="loading">
      <template #template>
        <div v-for="i in 4" :key="i" class="flex my-3">
          <el-skeleton-item class="w-90px siblings:ml-3 h-6" variant="title" />
          <el-skeleton-item class="flex-1 h-6" />
        </div>
      </template>
      <filter-bar name="目的地" :is-all="city.length == 0" :options="filterData.city" @on-clear="handleClearSearch('city')">
        <template #item="{ option }">
          <v-checkbox :value="city" :val="option.city_id" @input="onFilterInput('city', $event)">
            <div :class="$style.label">{{ option.city_name }}</div>
          </v-checkbox>
        </template>
      </filter-bar>
      <filter-bar :class="$style.dateFilter" name="出发日期" :options="dateArr" :is-all="months.length == 0" type="group"
        @on-clear="handleClearSearch('months')">
        <template #item="{option}">
            <v-checkbox
                :val="option.value"
                @input="onFilterInput('months', $event)"
                :value="months"
            >
                {{ option.name }}
            </v-checkbox>
        </template>
      </filter-bar>
      <filter-bar name="行程天数" :options="filterData.days" :is-all="days_range.length == 0"
        @on-clear="handleClearSearch('days_range')">
        <template #item="{ option }">
          <v-checkbox :value="days_range" :val="`${option.gte}-${option.lte}`"
            @input="onFilterInput('days_range', $event)">{{ option.value }}</v-checkbox>
        </template>
      </filter-bar>
      <filter-bar name="价格区间" :options="filterData.price" :is-all="price_range.length == 0"
        @on-clear="handleClearSearch('price_range')">
        <template #item="{ option }">
          <v-checkbox :value="price_range" :val="`${option.gt}-${option.lte}`"
            @input="onFilterInput('price_range', $event)">{{ option.value }}</v-checkbox>
        </template>
      </filter-bar>
      <filter-bar name="假期选择" :options="filterData.holiday" :is-all="holidays.length == 0"
        @on-clear="handleClearSearch('holidays')">
        <template #item="{ option }">
          <v-checkbox :value="holidays" :val="option.value" @input="onFilterInput('holidays', $event)">
            {{ option.name }}
          </v-checkbox>
        </template>
      </filter-bar>
      <filter-bar name="标签" :options="filterData.product_type" :is-all="product_type.length == 0"
        @on-clear="handleClearSearch('product_type')">
        <template #item="{ option }">
          <v-checkbox :value="product_type" :val="option.id" @input="onFilterInput('product_type', $event)">
            {{ option.name }}
          </v-checkbox>
        </template>
      </filter-bar>
    </el-skeleton>
  </div>
</template>

<script>
import { defineComponent, onBeforeMount } from "@nuxtjs/composition-api";
// import CheckboxGroup from "./ListFilterCheckboxGroup";
// import FilterBar from "./ListFilterBar.vue";
import FilterBar from "@/components/product/filterBar";

// import { createNamespacedHelpers } from "vuex";

import * as VacationService from "@/services/vacation.js";
import { REQUEST_CODES } from "@/constants/const-http";

export default defineComponent({
  name: "ListFilter",
  components: { FilterBar },
  props: {
    loading: Boolean,
    filterData: Object,
    holidays: Array,
    months: Array,
    days_range: Array,
    city: Array,
    price_range: Array,
    product_type: Array
  },
  setup(props) {
    const formatDateGroup = (dates)=>{
      let res = []
      if(!dates){
          return []
      }
      for(let i=0;i<dates.length;i++){
        let obj = {}
        const key = dates[i].year
        obj.group = key+'年'
        obj.value = dates[i].months
        res.push(obj)
      }
      return res
    }
    const dateArr = formatDateGroup(props.filterData.date)

    return {
      dateArr
    }
  },
  // data() {
  //   return {
  //     loading: false,
  //     filterData: {
  //       date: [],
  //       days: [],
  //       price: [],
  //       city: [],
  //       holiday: []
  //     }
  //   };
  // },
  // async created() {
  //   this.loading = true;
  //   await this.getFilterData();
  //   this.loading = false;
  // },
  methods: {
    async getFilterData() {
      let { code, data, msg } = await VacationService.getProductFilter();
      if (code !== REQUEST_CODES.ERROR_OK) {
        throw new Error(msg);
      }

      this.filterData = {
        ...data,
        city: data.city.map(item => ({
          ...item,
          city_id: String(item.city_id)
        }))
      };
    },
    handleClearSearch(key) {
      this.$emit(`update:${key}`, []);

      this.$nextTick(() => {
        this.$emit("on-filter-change");
      });
    },
    onFilterInput(key, value) {
      this.$emit(`update:${key}`, value);
      this.$nextTick(() => {
        this.$emit("on-filter-change");
      });
    },
  },
});
</script>

<style lang="scss" module>

// @import "~@/assets/scss/base/_color";

.filter {
  --label-font-size: var(--font-size);

  background: #fff;

  // padding: 13px 17px;
  &-item {
    width: 16.5555%;
    margin-top: 8px;
    margin-bottom: 8px;

    &.all-wraper {
      width: 60px;
    }
  }
}

.label {
  max-width: 5.5em;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dateFilter{
  ::v-deep{
    .g-grow{
      margin-right: 14px;
    }
  }
}

</style>
